'use strict';
var $ = jQuery;

function updateTopFilterMargin() {
    var $tilesContainer = $('.plp-tiles-container');
    var $activeTopFilter = $('.refinements.top-filters').find('.refinement.active');

    if ($activeTopFilter.length) {
        var activeBodyHeight = $activeTopFilter.find('.card-body').outerHeight(true);
        $tilesContainer.css({
            'margin-top': activeBodyHeight + 'px'
        });
    } else {
        $tilesContainer.css('margin-top', '');
    }
}

function observeTopFilterStateChanges() {
    if (typeof window.MutationObserver !== 'function') {
        return;
    }

    var observer = new window.MutationObserver(function (mutations) {
        var shouldUpdate = mutations.some(function (mutation) {
            if (mutation.type === 'attributes') {
                var $target = $(mutation.target);
                return $target.hasClass('refinement') && $target.closest('.refinements.top-filters').length > 0;
            }

            if (mutation.type === 'childList') {
                var $targetNode = $(mutation.target);
                return $targetNode.closest('.refinements.top-filters').length > 0 || $targetNode.find('.refinements.top-filters').length > 0;
            }

            return false;
        });

        if (shouldUpdate) {
            updateTopFilterMargin();
        }
    });

    observer.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
    });
}

/**
 * Overriding from base SFRA to fix nested collapsibles
 */

module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
 
    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
 
        $('body').on('click', selector, function (e) {
            e.preventDefault();
 
            var $this = $(this);
            var $collapsible = $this.closest('.collapsible-' + size);
            var $cardBody = $collapsible.find('.card-body');
 
            var isTopFilter = $collapsible.closest('.refinements.top-filters').length > 0;
 
            // Close other filters only when clicked filter is top-filter
            // Sidebar filters should stay open together
            if (isTopFilter) {
                $('[class*="collapsible-"]').not($collapsible).each(function () {
                    var $item = $(this);
                    var itemIsTopFilter = $item.closest('.refinements.top-filters').length > 0;
 
                    // Close only other top filters
                    if (itemIsTopFilter) {
                        $item.removeClass('active');
                        $item.find('.title').attr('aria-expanded', false);
                    }
                });
            }
 
            // Toggle clicked filter
            $collapsible.toggleClass('active');
 
            if ($collapsible.hasClass('active')) {
                $this.attr('aria-expanded', true);
            } else {
                $this.attr('aria-expanded', false);
            }
 
            // Manage top-filter margin
            updateTopFilterMargin();
        });
    });
};

$(document).ready(function () {
    observeTopFilterStateChanges();
    updateTopFilterMargin();
});

$('body').on('click', '.custom-sort-btn', function () {

    $(this)
        .next('.custom-sort-list')
        .toggle();
});

$('body').on('click', '.custom-sort-item', function () {
    var url = $(this).data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        data: {
            selectedUrl: url
        },
        method: 'GET',
        success: function (response) {
            $('.product-grid').empty().html(response);
            $.spinner().stop();
            $('.custom-sort-list').hide();
        },
        error: function () {
            $.spinner().stop();
            $('.custom-sort-list').hide();
        }
    });
});

$(document).on('click', function (e) {

    if (!$(e.target).closest('.custom-sort').length) {
        $('.custom-sort-list').hide();
    }
});
